import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Typography, Chip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CircleIcon from "@mui/icons-material/Circle";
import ListItemIcon from "@mui/material/ListItemIcon";
import findIndex from "lodash/findIndex";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const SelectionList = (props) => {
  // State
  const [checked, setChecked] = useState(false);

  // Redux state
  const selectedAssets = useSelector((state) => state.task.selectedAssets);
  const { selectedTasks, selectedLearners } = useSelector(
    (state) => state.assignment
  );

  // React logic hooks
  useEffect(() => {
    if (selectedAssets.length == 0 && props.from == "TaskCreate") {
      setChecked(false);
    }
    if (
      !props.viewOnly &&
      selectedAssets.length > 0 &&
      props.from == "TaskCreate"
    ) {
      if (findIndex(selectedAssets, { id: props.value }) != -1) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [selectedAssets, props.from]);

  useEffect(() => {
    if (
      !props.viewOnly &&
      selectedTasks.length > 0 &&
      props.from == "TaskSelect"
    ) {
      if (findIndex(selectedTasks, { id: props.value }) != -1) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [selectedTasks, props.from]);

  useEffect(() => {
    if (selectedLearners.length == 0 && props.from == "LearnerSelect") {
      setChecked(false);
    }
    if (
      !props.viewOnly &&
      selectedLearners.length > 0 &&
      props.from == "LearnerSelect"
    ) {
      if (findIndex(selectedLearners, { id: props.value }) != -1) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [selectedLearners, props.from]);

  return (
    <Box sx={{ width: "100%" }}>
      <List sx={{ py: 0, px: 1 }}>
        <ListItem
          disablePadding
          secondaryAction={
            <>
              {!props.viewOnly && (
                // <IconButton
                //   edge="end"
                //   au6ria-label="comments"
                //   sx={{ color: "primary.main" }}
                // >
                //   <Typography
                //     sx={{ color: "#A9A9A9", pr: 2, fontSize: "0.8rem" }}
                //   >
                //     {""}
                //   </Typography>
                //   <VisibilityIcon sx={{ fontSize: "1rem" }} />
                // </IconButton>
                <></>
              )}
            </>
          }
        >
          <ListItemButton
            sx={{ borderRadius: 15, py: 0 }}
            onClick={() => {
              if (!props.viewOnly) {
                setChecked(!checked);
                props.checkTick(props.value, props.title, !checked);
              }
            }}
          >
            {!props.viewOnly && (
              <ListItemIcon>
                <CircleIcon
                  fontSize="small"
                  value="a"
                  name="radio-buttons"
                  sx={{ color: checked ? "#5f5600ff" : "#D9D9D9" }}
                />
              </ListItemIcon>
            )}
            <ListItemText sx={{ color: "#5f5600ff" }}>
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "500",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.2rem",
                  },
                }}
              >
                {props.title ? props.title : ""}
                {props.deleted && (
                  <Chip
                    size="small"
                    label={`Deleted`}
                    color="error"
                    sx={{ fontWeight: "700", fontSize: "1vw", ml:2 }}
                    variant="outlined"
                  ></Chip>
                )}
              </Typography>
            </ListItemText>
          </ListItemButton>
          {props.viewaction && (
            <RemoveRedEyeIcon
              fontSize="small"
              value="a"
              name="view-buttons"
              sx={{ color: "#DB8829", cursor: "pointer" }}
              onClick={props.view}
            />
          )}
        </ListItem>
      </List>
    </Box>
  );
};
export default SelectionList;
